import { render, staticRenderFns } from "./FacilityCreateLocation.vue?vue&type=template&id=60c959f2&"
import script from "./FacilityCreateLocation.vue?vue&type=script&lang=js&"
export * from "./FacilityCreateLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports